<section class="vc-admin-product-categories-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.PRODUCTS.ALL.CATEGORIES"
    descriptionKey="ADMIN.IA.PRODUCTS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'products', 'categories', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredProductsCategories.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.PRODUCTS.CATEGORIES.EMPTY.TITLE"
      descriptionKey="ADMIN.PRODUCTS.CATEGORIES.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredProductsCategories"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.PRODUCT.CATEGORY.NAME' | translate }}</th>
          <th>{{ 'COMMON.PRODUCT.CATEGORY.PRODUCTS' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-category>
        <tr>
          <td>{{ category.name }}</td>
          <td>{{ category.products?.length || 0 }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'products',
                'categories',
                category.id
              ]"
              (delete)="confirmDelete(category)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
